<template>

<span>

   <div v-if="serverResponse" class="habeo-border mx-sm-16 text-center">

    <br>
     <h2 class="bold"> {{ $t('shared.activities.bookingSuccess') }}  <br>
       <div
           style="color: #076207;padding:0.5em;font-size: 1.2em;">{{
           serverResponse.activityType.name
         }} :  {{ serverResponse.date |formatDateTime }} : {{
           totalPrice | currency
         }}</div><br>
       {{ $t('booking.confirmation.confirmation_mail') }} : {{ serverResponse.reservation.email }}</h2>
  </div>


  <v-form ref="form" v-if="!serverResponse" class="habeo-border mx-sm-16" :disabled="isLoading">

  <!--<v-form ref="form" class="habeo-border mx-sm-16" :disabled="isLoading">-->
    <v-row>

      <v-col cols="12" sm="5">
        <div style="display:block;">
          <v-select v-model="activity.activityType" :items="activitiesType" :label="$t('shared.activities.titleSingle')"
                    return-object
                    :item-text="(row) => {return row.name+ ' : ('+row.montantPerUnit  +' ' +this.currency.name+')';}"
                    @change="manageAttendees()" required></v-select>
        </div>
      </v-col>

      <v-col class="st" cols="12" sm="3">
        <v-datetime-picker :label="$t('main.availability_form.pickup_date_label')" v-model="activity.date" required>
          <v-icon slot="dateIcon">mdi-calendar-range</v-icon>
          <v-icon slot="timeIcon">mdi-clock-time-nine-outline</v-icon>
        </v-datetime-picker>
      </v-col>

      <v-col class="st" cols="12" sm="3">
        <v-text-field :label="$t('shared.activities.nombrePersonTotal')" type="number"
                      required v-model="activity.nombrePersonTotal"></v-text-field>
      </v-col>
    </v-row>

    <span v-if="activity.activityType">
        <small>{{ activity.activityType.tenant.name }} : {{ activity.activityType.description }}</small>
        <p>{{ $t('shared.activities.minPrice', [minPrice, activity.activityType.nombreMinUnitPourRes,activity.activityType.montantPerUnit,currency.name]) }}  </p>

        <h2 style="padding-top: 1.6em">{{ $t('shared.activities.bookingPerson') }} </h2>
        <PersonForm :is-upload-file="false" :person="activity.reservation"></PersonForm>


        <h2 style="padding-top: 0.6em">{{ $t('shared.activities.bookingAttendees') }}
          ( min {{ activity.activityType.nombreMinUnitPourRes }}  {{ $t('shared.activities.person') }} )
           <v-btn class="mx-4" fab small color="success" v-on:click="activity.units.push({})">
                <v-icon dark>mdi-plus</v-icon>
            </v-btn>
        </h2>
        <PersonForm :is-upload-file="true" :person="unit" :index-id="i" v-for="(unit, i) in activity.units" :key="i"></PersonForm>
    </span>


    <v-row style="padding-top: 1.8em">


      <v-col cols="12" sm="12" align="center">
          <v-alert type="warning" v-if="error">{{ $t('shared.requiredFields') }} {{ error }}</v-alert>
        <v-btn @click="book" size="is-medium" color="indigo" depressed outlined :loading="isLoading">
          <v-icon class="mr-2">book-edit-outline</v-icon>
          {{ activity.id?$t('shared.update'):$t('shared.book') }}
          : {{ totalPrice | currency }}
        </v-btn>
      </v-col>
    </v-row>


  </v-form>



</span>
</template>


<script>


import { ActivitiesApi } from '../services/api/activities'
import PersonForm from './PersonForm'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'ActivityForm',
  data () {
    return {
      //activity: { units: [], reservation: {nom:"te",prenom:"s",email:"vonyuri@gmail.com"} , date: new Date(),nombrePersonTotal:5 },
      activity: { units: [{}], reservation: {} },
      isLoading: false,
      error: null,
      activitiesType: [],
      serverResponse: null
    }
  },
  methods: {
    book () {
      console.log(this.activity, this.validateForm())
      if (!this.validateForm()) {
        this.error = '*'
        return
      }

      var formData = new FormData()
      for (const unit of this.activity.units) {
        console.log('unit', unit)
        if (unit.fileJustForProcessing) {
          formData.append('files', unit.fileJustForProcessing, unit.fileNameForProcessing)
        }
      }
      formData.append('activityString', JSON.stringify(this.activity))
      this.isLoading = true
      ActivitiesApi.createActivity(formData)
          .then((data) => {
            this.serverResponse = data

          })
          .catch(error => console.error(error))
          .finally(error => this.isLoading = false)
      //this.successResponse =   {};

    },
    manageAttendees () {
      console.debug('activityType selection', this.activity.activityType, this.activity.activityType.nombreMinUnitPourRes)
      if (this.activity.activityType) {
        // this.activity.units = new Array(this.activity.activityType.nombreMinUnitPourRes).fill().map((_, i) => ({ nom: '' }))
        // this.activity.units.push({ nom: '' });
      }
    },
    validateForm () {
      if (!this.activity || !this.activity.activityType || !this.activity.date) {
        return false
      }
      if (!this.validatePerson(this.activity.reservation)) {
        return false
      }
      for (const unit of this.activity.units) {
        if (!this.validatePerson(unit)) {
          return false
        }
      }
      return true
    },
    validatePerson (person) {
      if (person.nom && person.prenom) {
        return true
      }
      /*if (person.nom && person.prenom && person.email) {
        return true
      }*/
    },
    deleteLine (indexId) {
      console.log("DeleteLine ",indexId);
      this.activity.units.splice(indexId, 1);
    },
  },
  computed: {
    isSearchButtonDisabled () {
      return this.activity == null
    },
    totalPrice () {

      if (this.activity !== null && this.activity.activityType != null) {
        var total = this.activity.activityType.montantPerUnit * this.activity.units.length

        if (total < this.minPrice) {
          return this.minPrice
        } else {
          return total
        }
      }
      return ''
    },
    minPrice () {
      if (this.activity !== null && this.activity.activityType != null) {
        return this.activity.activityType.montantPerUnit * this.activity.activityType.nombreMinUnitPourRes
      }
      return 0
    },
    ...mapGetters({ currency: 'main/currency' })
  },
  mounted: function () {
    ActivitiesApi.getAllActivitiesTypePublic()
        .then((data) => {
          this.activitiesType = data
        })
        .catch(error => console.error(error))
        .finally()
    if (this.$route.query.activityUuid) {
      ActivitiesApi.activityManage(this.$route.query.activityUuid)
          .then((data) => {
            this.activity = data;
            this.activity.date = new Date(Date.parse(data.date));
          })
          .catch(error => {
            console.error(error)
            this.$root.bar.error({ message: this.$i18n.t('shared.invalidLink') })
          })
          .finally()
    }

  },
  components: {
    PersonForm
  }
}
</script>
